import React from 'react'
import { InnovationTimeline as GenericInnovationTimeline } from './component-legacy'
import { useMediaQuery, mq } from 'marketing-site/src/library/utils'
import { ITimeline } from './index'

export const InnovationTimeline: React.FC<Omit<ITimeline, 'isMobile'>> = (props) => {
  const isMobile = useMediaQuery(`(${mq.mobile})`)
  return <GenericInnovationTimeline {...props} isMobile={isMobile} />
}
